import citizenService from '../../services/citizen.service';

const state = {
  errors:'',
  status:''
};

const getters = {
  getReturnStatus: state => {
    return state.status;
  },
  getErrosOnSave: state => {
    return state.errors;
  }
};

const mutations = {
  save: (state, payload) => {
    state.status  = payload.status;
    state.errors = payload.errors;
  },

};

const actions = {

      save: async ({ commit }, data) => {
        const response = await citizenService.save(data);
        data.status = response.status;
        if (response.status.toLowerCase() !== 'ok') {
          data.errors = response.errors;
        } 
        commit('save', data);
      },
};


export default {
    namespaced:true,
    state,
    getters,
    mutations,
    actions
};